import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ProjectElement, ListProjects, ListProjectZones } from '../models/project.model';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../environments/environment';

const API_URL = environment.API_URL


@Injectable({
  providedIn: 'root'
})

export class ProjectService {

  lstProjects: ListProjects[] = [];
  lstProjectZones: ListProjectZones[] = [];

  constructor(private http: HttpClient) { }

  items: any = [];

  getAllProjects(company_id: number): Observable<ProjectElement[]> {
    const API_URL_PRJ = `${API_URL}/companies/${company_id}/projects`;
    return this.http.get<ProjectElement[]>(`${API_URL_PRJ}`);
  }

  getProjectById(id: number, company_id: number): Observable<ProjectElement[]> {
    const API_URL_PRJ = `${API_URL}/companies/${company_id}/projects/${id}`;
    return this.http.get<ProjectElement[]>(`${API_URL_PRJ}`);
  }

  addProject(project: ProjectElement, company_id: number): Observable<any> {
    const API_URL_PRJ = `${API_URL}/companies/${company_id}/projects`;
    return this.http.post<ProjectElement[]>(`${API_URL_PRJ}`, project);
  }

  updateProject(id: number, project: ProjectElement, company_id: number): Observable<any> {
    const API_URL_PRJ = `${API_URL}/companies/${company_id}/projects/${id}`;
    return this.http.put<ProjectElement[]>(`${API_URL_PRJ}`, project);
  }

  deleteProject(id: number, company_id: number): Observable<any> {
    const API_URL_PRJ = `${API_URL}/companies/${company_id}/projects/${id}`;
    return this.http.delete<ProjectElement[]>(`${API_URL_PRJ}`);
  }

  getProjectsList(company_id: number):ListProjects[] {
    this.lstProjects=[];
    let itmExist;

    const req = this.getAllProjects(company_id);
    req.subscribe({
      next: (res) => {
        this.items = res;
        if(this.items.data != null){
          this.lstProjects.push( {value: undefined, viewValue: ''} );
          for (let itm of this.items.data ){
            itmExist = this.lstProjects.some((el)=>{ return el.value === itm.id });
            if (!itmExist){
              this.lstProjects.push( {value: itm.id, viewValue: itm.name} );
            }
          }
        }
      },
      error: (e) => {
        console.error(e);
        let msg = e.error.message;
      },
    });

    return this.lstProjects;
  }

  // ── Notification emails ───────────────────────────────────────────────────

  getNotificationEmails(projectId: number, companyId: number): Observable<any> {
    return this.http.get(`${API_URL}/companies/${companyId}/projects/${projectId}/notification-emails`);
  }

  addNotificationEmail(projectId: number, companyId: number, email: string, label?: string): Observable<any> {
    return this.http.post(`${API_URL}/companies/${companyId}/projects/${projectId}/notification-emails`, { email, label: label || null });
  }

  deleteNotificationEmail(projectId: number, companyId: number, id: number): Observable<any> {
    return this.http.delete(`${API_URL}/companies/${companyId}/projects/${projectId}/notification-emails/${id}`);
  }

  // ── Notification contacts ─────────────────────────────────────────────────

  getNotificationContacts(projectId: number, companyId: number): Observable<any> {
    return this.http.get(`${API_URL}/companies/${companyId}/projects/${projectId}/notification-contacts`);
  }

  addNotificationContact(projectId: number, companyId: number, userId: number): Observable<any> {
    return this.http.post(`${API_URL}/companies/${companyId}/projects/${projectId}/notification-contacts`, { user_id: userId });
  }

  deleteNotificationContact(projectId: number, companyId: number, id: number): Observable<any> {
    return this.http.delete(`${API_URL}/companies/${companyId}/projects/${projectId}/notification-contacts/${id}`);
  }

  getProjectZonesList(project_id: number, company_id: number):ListProjectZones[] {
    this.lstProjectZones=[];

      const req = this.getAllProjects(company_id);
      req.subscribe({
        next: (res) => {
          this.items = res;
          if(this.items.data != null){
            this.lstProjectZones.push( { project_id: undefined, value: undefined, viewValue: ''} );
            for (let itm of this.items.data ){
              if (itm.id==project_id){
                this.lstProjectZones.push( {project_id: itm.id, value: itm.zone_id, viewValue: itm.zone_name} );
              }
            }
          }
        },
        error: (e) => {
          console.error(e);
          let msg = e.error.message;
        },
      });

    return this.lstProjectZones;
  }

}
